import {fromJS} from 'immutable';
import settingsActions from '../actions/settings.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    slugOptions: [],
    profile: {},
    payoutAccount: {},
    taxInfo: {},
    w9Form: {},
    loading: true,
    loadingPayout: true,
    updateFailed: false,
    completedPayoutAndTax: false
});

export const settingsReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case settingsActions.TYPES.GET_SETTINGS: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case settingsActions.TYPES.GET_SETTINGS_COMPLETE: {
            const {profile, taxInfo, slugOptions} = action.payload;
            if (taxInfo && taxInfo.data) {
                taxInfo.data.taxId = taxInfo.data.status === 'ACTIVE' ? '*********' : '';
            }
            const currentState = state.toJS();
            newState = fromJS({
                ...currentState,
                slugOptions: slugOptions.data,
                profile: profile.data,
                loading: false
            });
            return newState;
        }

        case settingsActions.TYPES.GET_PAYOUT: {
            newState = newState.updateIn(['loadingPayout'], () => true);
            return newState;
        }

        case settingsActions.TYPES.GET_PAYOUT_COMPLETE: {
            const {payoutAccount, taxInfo} = action.payload;
            if (taxInfo && taxInfo.data) {
                taxInfo.data.taxId = taxInfo.data.status === 'ACTIVE' ? '*********' : '';
            }
            const currentState = state.toJS();
            newState = fromJS({
                ...currentState,
                payoutAccount: payoutAccount.data && payoutAccount.data[0],
                taxInfo: taxInfo.data,
                loadingPayout: false,
                completedPayoutAndTax:
                    payoutAccount.data &&
                    Object.keys(payoutAccount.data).length !== 0 &&
                    taxInfo.data &&
                    Object.keys(taxInfo.data).length !== 0
            });
            return newState;
        }

        case settingsActions.TYPES.UPDATE_SETTINGS: {
            const currentState = state.toJS();
            const payoutAccount = {...currentState, ...action.payload.payout};
            newState = newState.updateIn(['loadingPayout'], () => true);
            newState = newState.updateIn(['payoutAccount'], () => payoutAccount);
            return newState;
        }

        case settingsActions.TYPES.UPDATE_SETTINGS_COMPLETE: {
            const _payoutAccount = action.payload;
            const slugOptions = state.toJS().slugOptions;
            newState = fromJS({
                slugOptions,
                payoutAccount: _payoutAccount
                    ? _payoutAccount.data
                    : state.get('payoutAccount').toJS(),
                loadingPayout: false
            });
            return newState;
        }
        case settingsActions.TYPES.UPDATE_SETTINGS_FAILED: {
            newState = newState.updateIn(['updateFailed'], () => true);
            newState = newState.updateIn(['loadingPayout'], () => false);
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('settings', settingsReducer);
